import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { GalleryService } from 'src/app/services/gallery/gallery.service';
import { gsap } from 'gsap';
import { AudioService } from 'src/app/services/audio/audio.service';

@Component({
  selector: 'app-game-detail-page',
  templateUrl: './game-detail-page.component.html'
})
export class GameDetailPageComponent implements OnInit {

  public gamelist: any[] = [];
  public gameLaunchData: any
  public currentGameIndex = 0;

  constructor(
    private readonly galleryService: GalleryService,
    private cdr: ChangeDetectorRef,
    private audioService: AudioService
  ) {
  }

  ngOnInit() {

    this.galleryService.gameList$.subscribe((data) => {
      this.gameLaunchData = data;
    });

    this.galleryService.getGameList().then((allgames) => {
      this.sortGames(allgames);
    });
  }

  sortGames(allgames) {
    const favorites = allgames["Favorites"];
    const sortedFavorites = allgames.filter((game) => {
      if (!favorites) return false;
      let matched = false;
      for (let i = 0; i < favorites.length; i++) {
        if (game.id === favorites[i].id) matched = true;
      }
      return matched;
    }).sort((a, b) => {
      return favorites.findIndex((fav) => fav.id === a.id) - favorites.findIndex((fav) => fav.id === b.id);
    });
    const gamesWitoutFavorites = allgames.filter((game) => {
      if (!sortedFavorites) return true;
      let matched = false;
      for (let i = 0; i < sortedFavorites.length; i++) {
        if (game.id === sortedFavorites[i].id) {
          matched = true;
        }
      }
      return !matched;
    });

    this.gamelist = sortedFavorites?.concat(gamesWitoutFavorites) || allgames;
    if (this.gameLaunchData && this.gamelist.length > 0) {
      const index = this.gamelist.findIndex((game) => game.id === this.gameLaunchData.id);
      if (index !== -1) {
        this.currentGameIndex = index;
        this.galleryService.gameListSubject.next(this.gamelist[this.currentGameIndex]);
      }
    }
  }

  onForwardButtonClick() {
    this.audioService.playSound("GamePopupArrowClick")
    const elementToAnimate = document.getElementById('app-game-detail');
    this.slideOutToLeft(elementToAnimate).then(() => {
      if (this.currentGameIndex < this.gamelist.length - 1) {
        this.currentGameIndex++;
        this.galleryService.gameListSubject.next(this.gamelist[this.currentGameIndex]);
        this.cdr.detectChanges();
      }
      this.slideInFromRight(elementToAnimate);
    });
  }

  onBackwardButtonClick() {
    this.audioService.playSound("GamePopupArrowClick")
    const elementToAnimate = document.getElementById('app-game-detail');
    this.slideOutToRight(elementToAnimate).then(() => {
      if (this.currentGameIndex > 0) {
        this.currentGameIndex--;
        this.galleryService.gameListSubject.next(this.gamelist[this.currentGameIndex]);
        this.cdr.detectChanges();
      }
      this.slideInFromLeft(elementToAnimate);
    });
  }

  private slideInFromLeft(element: HTMLElement) {
    return gsap.fromTo(element, { x: '-200%', opacity: 0.8 }, { x: '0%', opacity: 1, duration: 0.3 });
  }

  private slideOutToLeft(element: HTMLElement) {
    return gsap.to(element, { x: '-200%', opacity: 0.8, duration: 0.3 });
  }

  private slideInFromRight(element: HTMLElement) {
    return gsap.fromTo(element, { x: '200%', opacity: 0.8 }, { x: '0%', opacity: 1, duration: 0.3 });
  }

  private slideOutToRight(element: HTMLElement) {
    return gsap.to(element, { x: '200%', opacity: 0.8, duration: 0.3 });
  }


}
